import { Check } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { LeftPanelSections, SuperAgentModels } from 'src/types';
import styles from './NinjaModeSelect.module.scss';
import { useActiveModel } from 'src/hooks/userSettingsHooks/useActiveModel';
import { SettingLLMModels } from 'src/types/settings';
import { Button } from 'src/v2/commonComponents/Button';
import {
  useComparingConversationsParams,
  useLeftPanelActions,
} from 'src/hooks';

type NinjaModeSelectProps = {
  onClose: () => void;
  onChange?: (value: string | undefined) => void;
  models?: SettingLLMModels;
  compareModel?: string;
};

export const NinjaModeSelect = ({
  onClose,
  onChange,
  compareModel,
}: NinjaModeSelectProps) => {
  const { activeModel, changeCurrentModel } = useActiveModel();
  const { setLeftPanelData } = useLeftPanelActions();
  const { isCompareMode } = useComparingConversationsParams();

  const handleChangeValue = (value?: SuperAgentModels) => {
    if (isCompareMode) {
      onChange?.(value);
    } else {
      changeCurrentModel(value);
    }

    onClose();
  };

  const handleGoToSettingsClick = () => {
    setLeftPanelData({
      panelType: LeftPanelSections.SETTINGS,
      isExpanded: true,
    });
    onClose();
  };

  return (
    <div className={styles.root}>
      <div className={styles.rowWrapper} onClick={() => handleChangeValue()}>
        <div className={styles.labelWrapper}>
          <span className={styles.title}>Ninja Mode</span>
          <span className={styles.description}>
            Orchestrates using preferred AI models. See{' '}
            <Button
              color="link"
              onClick={handleGoToSettingsClick}
              className={styles.link}
            >
              Skill Settings
            </Button>
          </span>
        </div>
        <div>
          {!(activeModel || compareModel) && <Check size={SVG_SIZE_M} />}
        </div>
      </div>
    </div>
  );
};
